import React from 'react';
import { makeStyles, createStyles, Grid } from '@material-ui/core';

import { HomeContext } from '../../Home/HomeContext';
import { PageLocation } from '../../../shared/enum/PageLocation';
import { UserInput } from './UserInput';
import { UserSearch } from './UserSearch';
import { UserModel, userModelInitial } from '../../../Models/UserModel';
import { UserContext } from '../UserContext';

const useStyles = makeStyles(() => createStyles({
    gridContainer: {
        maxWidth: '1152px',
        margin: 0
    },
}));

export function User() {
    const classes = useStyles();

    const homeContext = React.useContext(HomeContext);

    const [user, setUser] = React.useState<UserModel>(userModelInitial);
    const [userList, setUserList] = React.useState<UserModel[]>([]);

    return (
        <UserContext.Provider value={{
            user, setUser,
            userList, setUserList,
        }}>
            <Grid container justify="center" alignItems="center">
                <Grid container justify="center" className={classes.gridContainer} spacing={2}>
                    {homeContext.pageLocation === PageLocation.USER_INPUT && <UserInput />}
                    {homeContext.pageLocation === PageLocation.USER_EDIT && <UserInput />}
                    {homeContext.pageLocation === PageLocation.USER_SEARCH && <UserSearch />}
                </Grid>
            </Grid>
        </UserContext.Provider>
    );

}